import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../../components/EnrollmentModal'

export function Canada() {
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600">EMR</Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="bg-gradient-to-br from-red-50 via-white to-red-50 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-6xl mb-6">🇨🇦</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            EMR for <span className="text-red-600">Canada</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Purpose-built for Canadian healthcare with full OHIP, MSP, AHCIP, and RAMQ billing integration.
            PIPEDA compliant with provincial health card validation.
          </p>
          <button
            onClick={() => setEnrollmentModalOpen(true)}
            className="bg-red-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-red-700 transition"
          >
            Start Free Trial
          </button>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Canadian Healthcare Features</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💳</div>
              <h3 className="text-xl font-semibold mb-2">Provincial Billing</h3>
              <p className="text-gray-600">
                Direct integration with OHIP, MSP, AHCIP, RAMQ, and other provincial billing systems.
                Real-time claim submission and remittance processing.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🆔</div>
              <h3 className="text-xl font-semibold mb-2">Health Card Validation</h3>
              <p className="text-gray-600">
                Multi-provincial health card validation (ON, BC, AB, QC, SK, MB, NS, NB, PE, NL, NT, YT, NU).
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">📋</div>
              <h3 className="text-xl font-semibold mb-2">SADIE Integration</h3>
              <p className="text-gray-600">
                Electronic Special Authorization forms with auto-completion, validation, and real-time status tracking.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🏥</div>
              <h3 className="text-xl font-semibold mb-2">ICD-10-CA Coding</h3>
              <p className="text-gray-600">
                Full support for Canadian ICD-10-CA diagnosis coding and SNOMED CT Canada terminology.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💊</div>
              <h3 className="text-xl font-semibold mb-2">PharmaNet</h3>
              <p className="text-gray-600">
                British Columbia PharmaNet integration for prescription drug monitoring and e-prescribing.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🔐</div>
              <h3 className="text-xl font-semibold mb-2">PIPEDA Compliant</h3>
              <p className="text-gray-600">
                Full compliance with Canadian privacy laws, provincial health information acts, and data residency requirements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-white hover:text-blue-400 transition">← Back to Home</Link>
          <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} EMR System. All rights reserved.</p>
        </div>
      </footer>

      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

